import React, { useEffect,useContext ,useRef,useState} from 'react'
import notesContext from '../context/notes/notesContext'

import NotesItem from './NotesItem'
import AddNote from './AddNote'
import { useNavigate } from 'react-router-dom'

const Notes = (props) => {
  let history=useNavigate();
   const{showAlert}=props
    const context= useContext(notesContext)
    const{notes,fetchNote,addNote,editNote}=context
    const [note,setNote]=useState({id:"",edtitle :"",eddescription :"",edtag:"default"})
    
    useEffect(()=>{
      if(localStorage.getItem('token')){
      fetchNote();
      }
      else{
        history('/login')
      }

      // eslint disable next line
    },[])
    
    const ref = useRef(null)
    const refclose=useRef(null)
    
    const updateNote=(currentnote)=>{
   ref.current.click()
   setNote({id:currentnote._id,edtitle:currentnote.title,eddescription:currentnote.description,edtag:currentnote.tag})
    }

    const handleClick=(e)=>{
      editNote(note.id,note.edtitle,note.eddescription,note.edtag)
    refclose.current.click()
     showAlert("Notes Updated Successfully","success");
   }
   
  const handleChange=(e)=>{
       setNote({...note,[e.target.name] : e.target.value})
   }
  return (
    <>
       <AddNote showAlert={showAlert}/>
       
<button  ref={ref} type="button"  className="btn btn-primary d-none" data-bs-toggle="modal"  data-bs-target="#exampleModalCenter">
  Launch demo modal
</button>


<div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" >
  <div className="modal-dialog modal-dialog-centered" role="document"  >
    <div className="modal-content">
      <div className="modal-header" style={{color:"#1E52A8"}}>
        <h5 className="modal-title" id="exampleModalLongTitle" >Update Your Memories</h5>
        <button type="button" className="close " data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" style={{fontSize:'22px'}}>&times;</span>
        </button>
      </div>
      <div className="modal-body">
      <form>
  <div className="mb-3">
    <label htmlFor="edtitle" className="form-label" style={{color:"#1E52A8"}}>Title</label>
    <input type="text" className="form-control" id="edtitle" name="edtitle" aria-describedby="emailHelp" value={note.edtitle} onChange={handleChange} />
    
  </div>
  <div className="mb-3">
    <label htmlFor="eddescription" className="form-label" style={{color:"#1E52A8"}}>Content</label>
    <textarea type="text" className="form-control" style={{height:'150px'}} id="eddescription" name="eddescription" value={note.eddescription} onChange={handleChange} />
  </div>
  
  <div className="mb-3">
    <label htmlFor="edtag" className="form-label" style={{color:"#1E52A8"}}>Tag</label>
    <input type="text" className="form-control" id="edtag" name="edtag" value={note.edtag} onChange={handleChange} />
  </div>

  
</form>


      </div>
      <div className="modal-footer">
        <button ref={refclose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button onClick={handleClick} type="button" className="btn btn-primary" >Save </button>
      </div>
    </div>
  </div>
</div>
        <div className="row my-10">
        <h1 className='text-center'>Your Collections</h1>
        {notes.map((note,idx)=>{
            return <NotesItem key={idx} note = {note} updateNote={updateNote}/>
        })}
        </div>
        
        </>
  )
}

export default Notes